import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

export interface SiaEventLog {
  Id: number;
  LogDateTime: string;
  LogText: string;
  EventType: string;
}

export interface SiaReceivedMessage {
  Id: number;
  FullMessage: string;
  EventValue: string;
  EventCode: string;
  EventPar1: string;
  EventPar2: string;
  SiteCode: string;
  SenderIP: string;
  EventDateTime: string;
  MessageId: string;
}

export interface SiaSiteConfig {
  Id?: number;
  SiteCode: string;
  Enabled: boolean;
  AcceptedIPs: string;
  SiaServerId: string;
  AreaId?: number;
  Area?: any;
}

export interface SiaCodeCustom {
  Id?: number;
  SiteConfigId: number;
  EventCode: string;
  EventValue: string;
  Description: string;
}

@Injectable({
  providedIn: "root",
})
export class SialinkService {
  private baseUrl = (environment as any).apiUrl + "/sialink";

  constructor(private http: HttpClient) {}

  getEvents(
    startDate?: string,
    endDate?: string,
    siteCode?: string,
    areaId?: number,
    excludeInfoTest?: boolean
  ): Observable<SiaEventLog[]> {
    let params = new HttpParams();
    if (startDate) params = params.set("startDate", startDate);
    if (endDate) params = params.set("endDate", endDate);
    if (siteCode) params = params.set("siteCode", siteCode);
    if (areaId) params = params.set("areaId", areaId.toString());
    if (excludeInfoTest) params = params.set("excludeInfoTest", "true");

    return this.http.get<SiaEventLog[]>(`${this.baseUrl}/events`, { params });
  }

  getRawMessages(
    startDate?: string,
    endDate?: string,
    siteCode?: string,
    areaId?: number,
  ): Observable<SiaReceivedMessage[]> {
    let params = new HttpParams();
    if (startDate) params = params.set("startDate", startDate);
    if (endDate) params = params.set("endDate", endDate);
    if (siteCode) params = params.set("siteCode", siteCode);
    if (areaId) params = params.set("areaId", areaId.toString());

    return this.http.get<SiaReceivedMessage[]>(`${this.baseUrl}/raw`, {
      params,
    });
  }

  // Configuration Methods

  getSites(areaId?: number): Observable<SiaSiteConfig[]> {
    let params = new HttpParams();
    if (areaId) params = params.set("areaId", areaId.toString());

    return this.http.get<SiaSiteConfig[]>(`${this.baseUrl}/sites`, { params });
  }

  createSite(site: SiaSiteConfig): Observable<SiaSiteConfig> {
    return this.http.post<SiaSiteConfig>(`${this.baseUrl}/sites`, site);
  }

  updateSite(site: SiaSiteConfig): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/sites/${site.Id}`, site);
  }

  deleteSite(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/sites/${id}`);
  }

  getCustomCodes(siteId: number): Observable<SiaCodeCustom[]> {
    return this.http.get<SiaCodeCustom[]>(
      `${this.baseUrl}/sites/${siteId}/codes`,
    );
  }

  createCustomCode(code: SiaCodeCustom): Observable<SiaCodeCustom> {
    return this.http.post<SiaCodeCustom>(`${this.baseUrl}/custom-codes`, code);
  }

  updateCustomCode(code: SiaCodeCustom): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/custom-codes/${code.Id}`, code);
  }

  deleteCustomCode(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/custom-codes/${id}`);
  }
}
